import Contrast from '../images/portfolio/contrast/contrast.png'
import Contrast1 from '../images/portfolio/contrast/contrast6.png'
import Contrast2 from '../images/portfolio/contrast/contrast2.png'
import Contrast3 from '../images/portfolio/contrast/contrast3.png'
import Contrast4 from '../images/portfolio/contrast/contrast4.png'
import Contrast5 from '../images/portfolio/contrast/contrast5.png'

import Contrasto from '../images/portfolio/Contrasto/1.jpg'
import Contrasto2 from '../images/portfolio/Contrasto/2.jpg'
import Contrasto3 from '../images/portfolio/Contrasto/3.jpg'
import Contrasto4 from '../images/portfolio/Contrasto/4.jpg'

import Smeg from '../images/portfolio/Smeg/1.jpg'
import Smeg2 from '../images/portfolio/Smeg/2.jpg'
import Smeg3 from '../images/portfolio/Smeg/3.jpg'
import Smeg4 from '../images/portfolio/Smeg/4.jpg'
import Smeg5 from '../images/portfolio/Smeg/5.jpg'
import Smeg6 from '../images/portfolio/Smeg/6.jpg'
import Smeg7 from '../images/portfolio/Smeg/7.jpg'
import Smeg8 from '../images/portfolio/Smeg/8.jpg'

import SmegKazn from '../images/portfolio/SMEGKazn/1.png'
import SmegKazn2 from '../images/portfolio/SMEGKazn/2.jpg'
import SmegKazn3 from '../images/portfolio/SMEGKazn/3.jpg'
import SmegKazn4 from '../images/portfolio/SMEGKazn/4.jpg'
import SmegKazn5 from '../images/portfolio/SMEGKazn/5.jpg'
import SmegKazn6 from '../images/portfolio/SMEGKazn/6.jpg'
import SmegKazn7 from '../images/portfolio/SMEGKazn/7.jpg'
import SmegKazn8 from '../images/portfolio/SMEGKazn/8.jpg'
import SmegKazn9 from '../images/portfolio/SMEGKazn/9.jpg'
import SmegKazn10 from '../images/portfolio/SMEGKazn/10.jpg'
import SmegKazn12 from '../images/portfolio/SMEGKazn/12.jpg'
import SmegKazn13 from '../images/portfolio/SMEGKazn/13.jpg'
import SmegKazn14 from '../images/portfolio/SMEGKazn/14.jpg'
import SmegKazn15 from '../images/portfolio/SMEGKazn/15.jpg'
import SmegKazn16 from '../images/portfolio/SMEGKazn/16.jpg'

import Hostel from '../images/portfolio/Hostel/1.jpg'
import Hostel2 from '../images/portfolio/Hostel/2.jpg'
import Hostel3 from '../images/portfolio/Hostel/3.jpg'
import Hostel4 from '../images/portfolio/Hostel/4.jpg'
import Hostel5 from '../images/portfolio/Hostel/5.jpg'
import Hostel6 from '../images/portfolio/Hostel/6.jpg'
import Hostel7 from '../images/portfolio/Hostel/7.jpg'
import Hostel8 from '../images/portfolio/Hostel/8.jpg'
import Hostel9 from '../images/portfolio/Hostel/9.jpg'
import Hostel10 from '../images/portfolio/Hostel/10.jpg'
import Hostel11 from '../images/portfolio/Hostel/11.jpg'

import MirMition from '../images/portfolio/MirMitino/1.jpg'
import MirMition2 from '../images/portfolio/MirMitino/2.jpg'
import MirMition3 from '../images/portfolio/MirMitino/3.jpeg'
import MirMition4 from '../images/portfolio/MirMitino/4.jpeg'
import MirMition5 from '../images/portfolio/MirMitino/5.jpg'
import MirMition6 from '../images/portfolio/MirMitino/6.jpg'
import MirMition7 from '../images/portfolio/MirMitino/7.jpg'
import MirMition8 from '../images/portfolio/MirMitino/8.jpg'
import MirMition9 from '../images/portfolio/MirMitino/9.jpg'
import MirMition10 from '../images/portfolio/MirMitino/10.jpg'
import MirMition11 from '../images/portfolio/MirMitino/11.jpg'
import MirMition12 from '../images/portfolio/MirMitino/12.jpg'
import MirMition13 from '../images/portfolio/MirMitino/13.jpg'
import MirMition14 from '../images/portfolio/MirMitino/14.jpg'

import Molodezhny from '../images/portfolio/Molodezhny/1.jpg'
import Molodezhny2 from '../images/portfolio/Molodezhny/2.jpg'
import Molodezhny3 from '../images/portfolio/Molodezhny/3.jpg'
import Molodezhny4 from '../images/portfolio/Molodezhny/4.jpg'
import Molodezhny5 from '../images/portfolio/Molodezhny/5.jpg'
import Molodezhny6 from '../images/portfolio/Molodezhny/6.jpg'
import Molodezhny7 from '../images/portfolio/Molodezhny/7.jpg'

import Myasnitskaya from '../images/portfolio/Myasnitskaya/1.jpg'
import Myasnitskaya2 from '../images/portfolio/Myasnitskaya/2.jpg'
import Myasnitskaya3 from '../images/portfolio/Myasnitskaya/3.jpg'
import Myasnitskaya4 from '../images/portfolio/Myasnitskaya/4.jpg'
import Myasnitskaya5 from '../images/portfolio/Myasnitskaya/5.jpg'
import Myasnitskaya6 from '../images/portfolio/Myasnitskaya/6.jpg'
import Myasnitskaya7 from '../images/portfolio/Myasnitskaya/7.jpg'
import Myasnitskaya8 from '../images/portfolio/Myasnitskaya/8.jpg'
import Myasnitskaya9 from '../images/portfolio/Myasnitskaya/9.jpg'
import Myasnitskaya10 from '../images/portfolio/Myasnitskaya/10.jpg'
import Myasnitskaya11 from '../images/portfolio/Myasnitskaya/11.jpg'

import PrimeTime from '../images/portfolio/PrimeTime/1.jpg'
import PrimeTime2 from '../images/portfolio/PrimeTime/2.jpg'
import PrimeTime3 from '../images/portfolio/PrimeTime/3.jpg'
import PrimeTime4 from '../images/portfolio/PrimeTime/4.jpg'
import PrimeTime5 from '../images/portfolio/PrimeTime/5.jpg'
import PrimeTime6 from '../images/portfolio/PrimeTime/6.jpg'
import PrimeTime7 from '../images/portfolio/PrimeTime/7.jpg'
import PrimeTime8 from '../images/portfolio/PrimeTime/8.jpg'
import PrimeTime9 from '../images/portfolio/PrimeTime/9.jpg'
import PrimeTime10 from '../images/portfolio/PrimeTime/10.jpg'
import PrimeTime11 from '../images/portfolio/PrimeTime/11.jpg'
import PrimeTime12 from '../images/portfolio/PrimeTime/12.jpg'
import PrimeTime13 from '../images/portfolio/PrimeTime/13.jpg'
import PrimeTime14 from '../images/portfolio/PrimeTime/14.jpg'
import PrimeTime15 from '../images/portfolio/PrimeTime/15.jpg'

import Moscow from '../images/portfolio/Moscow/1.jpg'
import Moscow2 from '../images/portfolio/Moscow/2.jpg'
import Moscow3 from '../images/portfolio/Moscow/3.jpg'
import Moscow4 from '../images/portfolio/Moscow/4.jpg'
import Moscow5 from '../images/portfolio/Moscow/5.jpg'
import Moscow6 from '../images/portfolio/Moscow/6.jpg'

import RedSide from '../images/portfolio/RedSide/1.jpg'
import RedSide2 from '../images/portfolio/RedSide/2.jpg'
import RedSide3 from '../images/portfolio/RedSide/3.jpg'
import RedSide4 from '../images/portfolio/RedSide/4.jpg'
import RedSide5 from '../images/portfolio/RedSide/5.jpg'
import RedSide6 from '../images/portfolio/RedSide/6.jpg'
import RedSide7 from '../images/portfolio/RedSide/7.jpg'
import RedSide8 from '../images/portfolio/RedSide/8.jpg'

import Esenino from '../images/portfolio/Esenino/1.jpg'
import Esenino2 from '../images/portfolio/Esenino/2.jpg'
import Esenino3 from '../images/portfolio/Esenino/3.jpg'
import Esenino4 from '../images/portfolio/Esenino/4.jpg'
import Esenino5 from '../images/portfolio/Esenino/5.jpg'
import Esenino6 from '../images/portfolio/Esenino/7.jpg'
import Esenino7 from '../images/portfolio/Esenino/8.jpg'
import Esenino8 from '../images/portfolio/Esenino/6.jpg'
import Esenino9 from '../images/portfolio/Esenino/9.jpg'
import Esenino10 from '../images/portfolio/Esenino/10.jpg'

import Provans from '../images/portfolio/Provans/1.jpg'
import Provans2 from '../images/portfolio/Provans/2.jpg'
import Provans3 from '../images/portfolio/Provans/3.jpg'
import Provans4 from '../images/portfolio/Provans/4.jpg'
import Provans5 from '../images/portfolio/Provans/5.jpg'
import Provans6 from '../images/portfolio/Provans/6.jpg'

import Grand from '../images/portfolio/Grand/1.jpg'
import Grand2 from '../images/portfolio/Grand/2.jpg'
import Grand3 from '../images/portfolio/Grand/3.jpg'
import Grand4 from '../images/portfolio/Grand/4.jpg'
import Grand5 from '../images/portfolio/Grand/5.jpg'
import Grand6 from '../images/portfolio/Grand/6.jpg'
import Grand7 from '../images/portfolio/Grand/7.jpg'
import Grand8 from '../images/portfolio/Grand/8.jpg'
import Grand9 from '../images/portfolio/Grand/9.jpg'
import Grand10 from '../images/portfolio/Grand/10.jpg'
import Grand11 from '../images/portfolio/Grand/11.jpg'
import Grand12 from '../images/portfolio/Grand/12.jpg'
import Grand13 from '../images/portfolio/Grand/13.jpg'
import Grand14 from '../images/portfolio/Grand/14.jpg'
import Grand15 from '../images/portfolio/Grand/15.jpg'
import Grand16 from '../images/portfolio/Grand/16.jpg'
import Grand17 from '../images/portfolio/Grand/17.jpg'
import Grand18 from '../images/portfolio/Grand/18.jpg'
import Grand19 from '../images/portfolio/Grand/19.jpg'
import Grand20 from '../images/portfolio/Grand/20.jpg'
import Grand21 from '../images/portfolio/Grand/21.jpg'

import Chine from '../images/portfolio/Chine/1.jpg'
import Chine2 from '../images/portfolio/Chine/2.jpg'
import Chine3 from '../images/portfolio/Chine/3.jpg'
import Chine4 from '../images/portfolio/Chine/4.jpg'
import Chine5 from '../images/portfolio/Chine/5.jpg'
import Chine6 from '../images/portfolio/Chine/6.jpg'

import Okta from '../images/portfolio/OKTA/1.jpg'
import Okta2 from '../images/portfolio/OKTA/2.jpg'
import Okta3 from '../images/portfolio/OKTA/3.jpg'
import Okta4 from '../images/portfolio/OKTA/4.jpg'
import Okta5 from '../images/portfolio/OKTA/5.jpg'
import Okta6 from '../images/portfolio/OKTA/6.jpg'
import Okta7 from '../images/portfolio/OKTA/7.jpg'
import Okta8 from '../images/portfolio/OKTA//8.jpg'

import Movie from '../images/portfolio/Movie/1.jpg'
import Movie2 from '../images/portfolio/Movie/2.jpg'
import Movie3 from '../images/portfolio/Movie/3.jpg'
import Movie4 from '../images/portfolio/Movie/4.jpg'
import Movie5 from '../images/portfolio/Movie/5.jpg'
import Movie6 from '../images/portfolio/Movie/6.jpg'

import OfSmeg from '../images/portfolio/OficeSmeg/1.jpg'
import OfSmeg2 from '../images/portfolio/OficeSmeg/2.jpg'
import OfSmeg3 from '../images/portfolio/OficeSmeg/3.jpg'
import OfSmeg4 from '../images/portfolio/OficeSmeg/4.jpg'

import Petrovskiy from '../images/portfolio/Petrovskiy/1.jpg'
import Petrovskiy2 from '../images/portfolio/Petrovskiy/2.jpg'
import Petrovskiy3 from '../images/portfolio/Petrovskiy/3.jpg'
import Petrovskiy4 from '../images/portfolio/Petrovskiy/4.jpg'

import IMoscow from '../images/portfolio/Moscow2/1.jpg'
import IMoscow2 from '../images/portfolio/Moscow2/2.png'
import IMoscow3 from '../images/portfolio/Moscow2/3.png'
import IMoscow4 from '../images/portfolio/Moscow2/4.png'
import IMoscow5 from '../images/portfolio/Moscow2/5.png'

import Club from '../images/portfolio/Club/1.jpg'
import Club2 from '../images/portfolio/Club/2.jpg'
import Club3 from '../images/portfolio/Club/3.jpg'
import Club4 from '../images/portfolio/Club/4.jpg'
import Club5 from '../images/portfolio/Club/5.jpg'
import Club6 from '../images/portfolio/Club/6.jpg'
import Club7 from '../images/portfolio/Club/7.jpg'
import Club8 from '../images/portfolio/Club/8.jpg'

import Covorking from '../images/portfolio/Covorking/1.jpg'
import Covorking2 from '../images/portfolio/Covorking/2.jpg'

import Rocket from '../images/portfolio/Rocket/1.jpg'
import Rocket2 from '../images/portfolio/Rocket/2.jpg'
import Rocket3 from '../images/portfolio/Rocket/3.jpg'
import Rocket4 from '../images/portfolio/Rocket/4.jpg'
import Rocket5 from '../images/portfolio/Rocket/5.jpg'
import Rocket6 from '../images/portfolio/Rocket/6.jpg'
import Rocket7 from '../images/portfolio/Rocket/7.jpg'

import Brand from '../images/portfolio/Brand/1.jpg'
import Brand2 from '../images/portfolio/Brand/2.jpg'
import Brand3 from '../images/portfolio/Brand/3.jpg'
import Brand4 from '../images/portfolio/Brand/4.jpg'
import Brand5 from '../images/portfolio/Brand/5.jpg'
import Brand6 from '../images/portfolio/Brand/6.jpg'
import Brand7 from '../images/portfolio/Brand/7.jpg'
import Brand8 from '../images/portfolio/Brand/8.jpg'
import Brand9 from '../images/portfolio/Brand/9.jpg'
import Brand10 from '../images/portfolio/Brand/10.jpg'
import Brand11 from '../images/portfolio/Brand/11.jpg'
import Brand12 from '../images/portfolio/Brand/12.jpg'
import Brand13 from '../images/portfolio/Brand/13.png'
import Brand14 from '../images/portfolio/Brand/14.png'
import Brand15 from '../images/portfolio/Brand/15.png'
import Brand16 from '../images/portfolio/Brand/16.png'
import Brand17 from '../images/portfolio/Brand/17.png'

import Showcase from '../images/portfolio/Showcase/1.jpg'
import Showcase2 from '../images/portfolio/Showcase/2.jpg'
import Showcase3 from '../images/portfolio/Showcase/3.jpg'

import SmegKrasn from '../images/portfolio/SMEGKrasn/1.jpg'
import SmegKrasn2 from '../images/portfolio/SMEGKrasn/2.jpg'
import SmegKrasn3 from '../images/portfolio/SMEGKrasn/3.jpg'
import SmegKrasn4 from '../images/portfolio/SMEGKrasn/4.jpg'
import SmegKrasn5 from '../images/portfolio/SMEGKrasn/5.jpg'

import SmegGorenje from '../images/portfolio/SmegGorenje/1.jpg'
import SmegGorenje2 from '../images/portfolio/SmegGorenje/2.jpg'
import SmegGorenje3 from '../images/portfolio/SmegGorenje/3.jpg'
import SmegGorenje4 from '../images/portfolio/SmegGorenje/4.jpg'
import SmegGorenje5 from '../images/portfolio/SmegGorenje/5.jpg'
import SmegGorenje6 from '../images/portfolio/SmegGorenje/6.jpg'
import SmegGorenje7 from '../images/portfolio/SmegGorenje/7.jpg'
import SmegGorenje8 from '../images/portfolio/SmegGorenje/8.jpg'
import SmegGorenje9 from '../images/portfolio/SmegGorenje/9.jpg'
import SmegGorenje10 from '../images/portfolio/SmegGorenje/10.jpg'
import SmegGorenje11 from '../images/portfolio/SmegGorenje/11.jpg'
import SmegGorenje12 from '../images/portfolio/SmegGorenje/12.jpg'
import SmegGorenje13 from '../images/portfolio/SmegGorenje/13.jpg'
import SmegGorenje14 from '../images/portfolio/SmegGorenje/14.jpg'
import SmegGorenje15 from '../images/portfolio/SmegGorenje/15.jpg'
import SmegGorenje16 from '../images/portfolio/SmegGorenje/16.jpg'
import SmegGorenje17 from '../images/portfolio/SmegGorenje/17.jpg'
import SmegGorenje18 from '../images/portfolio/SmegGorenje/18.jpg'
import SmegGorenje19 from '../images/portfolio/SmegGorenje/19.jpg'
import SmegGorenje20 from '../images/portfolio/SmegGorenje/20.jpg'
import SmegGorenje21 from '../images/portfolio/SmegGorenje/21.jpg'

import Croc from '../images/portfolio/CROC/1.jpg'
import Croc2 from '../images/portfolio/CROC/2.jpg'
import Croc3 from '../images/portfolio/CROC/3.jpg'
import Croc4 from '../images/portfolio/CROC/4.jpg'
import Croc5 from '../images/portfolio/CROC/5.jpg'
import Croc6 from '../images/portfolio/CROC/6.jpg'
import Croc7 from '../images/portfolio/CROC/7.jpg'

import Hotel from '../images/portfolio/Hotel/1.jpg'
import Hotel2 from '../images/portfolio/Hotel/2.jpg'
import Hotel3 from '../images/portfolio/Hotel/3.jpg'
import Hotel4 from '../images/portfolio/Hotel/4.jpg'
import Hotel5 from '../images/portfolio/Hotel/5.jpg'
import Hotel6 from '../images/portfolio/Hotel/6.jpg'
import Hotel7 from '../images/portfolio/Hotel/7.jpg'
import Hotel8 from '../images/portfolio/Hotel/8.jpg'
import Hotel9 from '../images/portfolio/Hotel/9.jpg'

import Room from '../images/portfolio/Room/1.jpg'
import Room2 from '../images/portfolio/Room/2.jpg'
import Room3 from '../images/portfolio/Room/3.jpg'
import Room4 from '../images/portfolio/Room/4.jpg'

import Exhibition from '../images/portfolio/Exhibition/1.png'
import Exhibition2 from '../images/portfolio/Exhibition/2.jpg'
import Exhibition3 from '../images/portfolio/Exhibition/3.jpg'
import Exhibition4 from '../images/portfolio/Exhibition/4.jpg'
import Exhibition5 from '../images/portfolio/Exhibition/5.jpg'
import Exhibition6 from '../images/portfolio/Exhibition/6.jpg'
import Exhibition7 from '../images/portfolio/Exhibition/7.jpg'
import Exhibition8 from '../images/portfolio/Exhibition/8.jpg'
import Exhibition9 from '../images/portfolio/Exhibition/9.png'
import Exhibition10 from '../images/portfolio/Exhibition/10.png'
import Exhibition11 from '../images/portfolio/Exhibition/11.jpg'
import Exhibition12 from '../images/portfolio/Exhibition/12.jpg'
import Exhibition13 from '../images/portfolio/Exhibition/13.jpg'
import Exhibition14 from '../images/portfolio/Exhibition/14.jpg'
import Exhibition15 from '../images/portfolio/Exhibition/15.jpg'
import Exhibition16 from '../images/portfolio/Exhibition/16.jpg'


import Holland from '../images/portfolio/Holland/1.jpg'
import Holland2 from '../images/portfolio/Holland/2.jpg'
import Holland3 from '../images/portfolio/Holland/3.jpg'
import Holland4 from '../images/portfolio/Holland/4.jpg'
import Holland5 from '../images/portfolio/Holland/5.jpg'
import Holland6 from '../images/portfolio/Holland/6.jpg'
import Holland7 from '../images/portfolio/Holland/7.jpg'
import Holland8 from '../images/portfolio/Holland/8.jpg'
import Holland9 from '../images/portfolio/Holland/9.jpg'
import Holland10 from '../images/portfolio/Holland/10.jpg'
import Holland11 from '../images/portfolio/Holland/11.jpg'
import Holland12 from '../images/portfolio/Holland/12.jpg'
import Holland13 from '../images/portfolio/Holland/13.jpg'
import Holland14 from '../images/portfolio/Holland/14.jpg'
import Holland15 from '../images/portfolio/Holland/15.jpg'
import Holland16 from '../images/portfolio/Holland/16.jpg'
import Holland17 from '../images/portfolio/Holland/17.jpg'
import Holland18 from '../images/portfolio/Holland/18.jpg'
import Holland19 from '../images/portfolio/Holland/19.jpg'
import Holland20 from '../images/portfolio/Holland/20.jpg'

import ExhibitionCity2 from '../images/portfolio/Exhibition2/2.JPG'
import ExhibitionCity3 from '../images/portfolio/Exhibition2/3.JPG'
import ExhibitionCity4 from '../images/portfolio/Exhibition2/4.JPG'
import ExhibitionCity5 from '../images/portfolio/Exhibition2/5.JPG'
import ExhibitionCity6 from '../images/portfolio/Exhibition2/6.JPG'
import ExhibitionCity7 from '../images/portfolio/Exhibition2/7.JPG'
import ExhibitionCity8 from '../images/portfolio/Exhibition2/8.JPG'
import ExhibitionCity9 from '../images/portfolio/Exhibition2/9.JPG'
import ExhibitionCity10 from '../images/portfolio/Exhibition2/10.jpg'
import ExhibitionCity11 from '../images/portfolio/Exhibition2/11.jpg'
import ExhibitionCity12 from '../images/portfolio/Exhibition2/12.jpg'
import ExhibitionCity13 from '../images/portfolio/Exhibition2/13.jpg'
import ExhibitionCity14 from '../images/portfolio/Exhibition2/14.jpg'
import ExhibitionCity15 from '../images/portfolio/Exhibition2/15.JPG'
import ExhibitionCity16 from '../images/portfolio/Exhibition2/16.jpg'
import ExhibitionCity17 from '../images/portfolio/Exhibition2/17.jpg'


export const Com = [
    {
        'id': '1',
        't': 'com',
        'category': 'Магазины и бутики',
        'type': 'Бутик',
        'name': 'Contrasto',
        'img': Contrast,
        'images': [
            Contrast1,
            Contrast2,
            Contrast3,
            Contrast4,
            Contrast5,
        ],
        'address': {
            'city': 'Москва',
            'tc': 'ТК Западный'
        },
        'square': '80',
        'info': [
            'Бутик «CONTRASTO» в ТК «Западный» г Москва, Рублевское шоссе д. 52-а, для дорогой женской одежды известных модельеров.',
            'В проекте использованы качественные, но не броские отделочные материалы, так как на первом месте всё таки должна быть одежда. Для создания приватной, атмосферы использовались мягкие цвета, отделка деревом и кирпичом, теплое освещение.',
            'За основу концепции было решено использовать образ древней Италии. Это стены с элементами античной кладки, сводчатые арки, декоративная штукатурка  «ANTIKO», декоративное окно из специально состаренной рамы, с видом на старую улицу итальянского городка,  подиум для манекенов из старой дубовой доски. Новшеством в оформлении  бутика была идея создания стены с эффектом растрескавшейся штукатурки и фрагмента фрески, с изображением показа мод.',
            'Общая идея заключалась в гармоничном сочетании современных элементов мебели, осветительных приборов, манекенов, натяжного потолка со  старинным интерьером. Особое внимание было уделено освещению. В духе современных трендов было использовано только локальное освещение, особые требования были к освещению зоны витрины. Также, в стиле современного подхода к дизайну интерьера и техники продаж, был продуман и осуществлен звукотехнический проект с использованием новейшей профессиональной акустической системы.'
        ]
    },
    {
        'id': '2',
        't': 'com',
        'category': 'Отели и рестораны',
        'type': 'Отель',
        'name': 'Grand Wellnes',
        'img': Grand,
        'images': [
            Grand2,
            Grand3,
            Grand4,
            Grand5,
            Grand6,
            Grand7,
            Grand8,
            Grand9,
            Grand10,
            Grand11,
            Grand12,
            Grand13,
            Grand14,
            Grand15,
            Grand16,
            Grand17,
            Grand18,
            Grand19,
            Grand20,
            Grand21,
        ],
        'address': {
            'city': 'Московская область',
            'tc': 'Новая Рига'
        },
        'square': '550',
        'info': [
            'Grand Wellness Hotel & SPA 5* на Новой Риге - единственный в Подмосковье отель, где акватермальный-комплекс 24/7, многофункциональный spa-комплекс и зона Wellness занимает  больше площади, чем номерной фонд отеля.',
            'Территория SPA с уникальными программами, 49 номеров различной категории индивидуальными дизайнерскими решениями.',
            'Аквазона с 6 бассейнами, оборудованными современной многоуровневой системой фильтрации воды, без использования хлора. Бассейн с подогревом под открытым небом в зоне отдыха. Термальный комплекс с 5 различными видами парных.',
            'Территория SPA с уникальными программами и новейшими технологиями anti-age. Круглосуточный фитнес-клуб с просторными залами и современными тренажерами. Авторская кухня в ресторанах с необычными локациями.',
            'В отеле прошла частичная реновация. Современные, комфортабельные номера, разработанные нашими дизайнерами, идеально вписались в уже существующую концепцию отеля. Лаконичный дизайн, качественные материалы и стильные аксессуары подчеркивают классическую направленность и лоск отеля. В отеле также сохранен пул номеров с индивидуальным дизайнерским решением.',
        ],
    },
    {
        'id': '3',
        't': 'com',
        'category': 'Магазины и бутики',
        'type': 'Шоурум',
        'name': 'Smeg',
        'img': Smeg,
        'images': [
            Smeg2,
            Smeg3,
            Smeg4,
            Smeg5,
            Smeg6,
            Smeg7,
            Smeg8
        ],
        'address': {
            'city': 'Москва',
            'tc': ''
        },
        'square': '550',
        'info': [
            'Московский шоу-рум бренда SMEG. Объем работы 550 кв м.',
            'Обновление шоу-рума, согласно бренд-буку, но с новой концепцией помещения. Минимальные реконструкции и демонтаж существующих экспозиций, минимальный бюджет на реализацию.',
            'Концепция проекта – привнести немного тепла Италии в нашу холодную Москву. Объединить традиции и современность. Яркость и лаконичность. Стиль 60-х и новые технологии.',
            'Подвесные арочные светильники спроектированы в нашей студии.'
        ],
    },
    {
        'id': '4',
        't': 'hom',
        'category': 'Квартиры',
        'type': 'Квартира',
        'name': 'Прайм тайм',
        'img': PrimeTime2,
        'images': [
            PrimeTime,
            PrimeTime7,
            PrimeTime2,
            PrimeTime3,
            PrimeTime4,
            PrimeTime6,
            PrimeTime5,
            PrimeTime7,
            PrimeTime8,
            PrimeTime12,
            PrimeTime9,
            PrimeTime13,
            PrimeTime14,
            PrimeTime15,
            PrimeTime10,
            PrimeTime11,
        ],
        'address': {
            'city': 'Москва',
            'tc': 'Прайм тайм'
        },
        'square': '124',
        'info': [
            'Две квартиры общей площадью 124 кв м , которые необходимо объединить.',
            'Для кого - дама 54 лет, работающая дома',
            'В квартире должны быть: вместительная кухня, гостиная с тв зоной, отдельный кабинет, спальня с гардеробной, ванная комната с душевой кабиной и отдельной ванной. Квартира должна разместить на ночлег 2 внуков, при необходимости.',
            'Квартира решена в спокойных природных тонах, с использованием натуральных отделочных материалов. Стилистика интерьера подразумевает лаконичность, но с нотками классики, что соответствует мироощущению владелицы и объединяет разные поколения.'
        ],
    },
    {
        'id': '5',
        't': 'hom',
        'category': 'Загородные клубы и дома',
        'type': 'Загородный дом',
        'name': 'Есенино',
        'img': Esenino,
        'images': [
            Esenino2,
            Esenino3,
            Esenino4,
            Esenino5,
            Esenino6,
            Esenino7,
            Esenino8,
            Esenino9,
            Esenino,
            Esenino10,
        ],
        'address': {
            'city': '',
            'tc': 'Есенино'
        },
        'square': '88',
        'info': [
            'Первый этаж загородного дома с уже готовой планировкой. Общая площадь 88 кв м.',
            'Для кого - семья с ребёнком, к которым часто приезжают гости и родственники в большом составе.',
            'Органично расположить кухню, большую зону столовой, гостиную с телевизором и камином, спроектировать лестницу, ведущую на 2-й и 3-й этажи.',
            'Первый этаж дома имеет большие окна в пол, что позволило использовать темные и насыщенные цвета. Цветовое и стилистическое решение дома позволили создать интерьер вне времени для яркой семьи.'
        ],
    },
    {
        'id': '6',
        't': 'hom',
        'category': 'Квартиры',
        'type': 'Квартира',
        'name': 'Молодёжный',
        'img': Molodezhny2,
        'images': [
            Molodezhny,
            Molodezhny3,
            Molodezhny4,
            Molodezhny5,
            Molodezhny6,
            Molodezhny7,
        ],
        'address': {
            'city': 'Москва',
            'tc': 'ЖК Молодёжный'
        },
        'square': '34',
        'info': [
            'Квартира в новостройке площадью 34 кв м.',
            'Для кого - молодая девушка 24 года',
            'Спроектировать квартиру для жизни и для приёма гостей с изолированной спальней. Планировочное решение позволило разместить на небольшой площади спальню, кухню- гостиную, гардеробную, отдельный хозблок и ванную комнату.',
            'Стилистика интерьера отражает харизму её владельца.'
        ],
    },
    {
        'id': '7',
        't': 'com',
        'category': 'Отели и рестораны',
        'type': '',
        'name': 'Хостел «12»',
        'img': Hostel,
        'images': [
            Hostel2,
            Hostel3,
            Hostel4,
            Hostel5,
            Hostel6,
            Hostel7,
            Hostel8,
            Hostel9,
            Hostel10,
            Hostel11,
        ],
        'address': {
            'city': 'Москва',
            'tc': ''
        },
        'square': '5180',
        'info': [
            'В разработку берутся зоны, общей площадью 2180 кв м : Ресепшен, коворкинг, стандартный 2-х местный номер гостиницы, 4-х местный номер хостела.',
            'Для кого - для людей, любящих путешествовать, людей, командированных в Москву на длительное время, для молодых семей с детьми и молодых компаний.',
            'Идея - рассказать о космосе простым, ярким и нестандартным  языком. Почему КОСМОС? Это тайна, которая манит. Это загадка, которую хочется разгадать.',
        ],
    },
    {
        'id': '8',
        't': 'com',
        'category': 'Офисы',
        'type': 'Офис',
        'name': 'ОКТА',
        'img': Okta,
        'images': [
            Okta2,
            Okta,
            Okta4,
            Okta5,
            Okta6,
            Okta8,
            Okta7,
            Okta3,
        ],
        'address': {
            'city': 'Москва',
            'tc': ''
        },
        'info': [
            'Офисное помещение в крупной IT компании.',
            'Для кого - коллектив из 35 человек',
            'Разместить необходимое количество сотрудников, разделив их на группы «Кому всегда холодно» и «Кому всегда жарко», две переговорные на 6 человек и одну переговорную для «тихих» звонков на 1-2 х человек.',
        ],
    },
    {
        'id': '9',
        't': 'hom',
        'category': 'Квартиры',
        'type': 'Квартира',
        'name': 'Мир Митино',
        'img': MirMition10,
        'images': [
            MirMition10,
            MirMition,
            MirMition2,
            MirMition3,
            MirMition4,
            MirMition5,
            MirMition6,
            MirMition7,
            MirMition9,
            MirMition11,
            MirMition8,
            MirMition12,
            MirMition13,
            MirMition14,
        ],
        'address': {
            'city': 'Москва',
            'tc': 'ЖК Мир Митино'
        },
        'square': '54',
        'info': [
            'Квартира в новостройке, площадью 54 кв м.',
            'Для кого - молодая семья, планирующая ребенка.',
            'Семье была необходима изолированная кухня, спальня и детская, которая пока может служить гостевой комнатой.Несмотря на небольшую площадь, нам удалось разместить всё необходимое для жизни молодой семьи.',
            'Стилистика интерьера – современно, но без минимализма - объединение разных вкусов супругов.'
        ],
    },
    {
        'id': '10',
        't': 'hom',
        'category': 'Квартиры',
        'type': 'Квартира',
        'name': 'Мясницкая',
        'img': Myasnitskaya2,
        'images': [
            Myasnitskaya,
            Myasnitskaya3,
            Myasnitskaya4,
            Myasnitskaya5,
            Myasnitskaya7,
            Myasnitskaya6,
            Myasnitskaya8,
            Myasnitskaya9,
            Myasnitskaya11,
            Myasnitskaya10,
            Myasnitskaya2

        ],
        'address': {
            'city': 'Москва',
            'tc': 'Мясницкая'
        },
        'square': '74',
        'info': [
            'Квартира в старом жилом фонде, площадью 74 кв м.',
            'Для кого - мужчина, творческой профессии.',
            'Небольшая кухня, гостиная с проектором, спальня с гардеробной – всё что нужно владельцу. Ко всему этому мы добавили зону столовой у окна.',
            'Выбор цветового и стилистического решения обусловлен любовью владельца ко всему неординарному и его образу жизни.'
        ],
    },
    {
        'id': '11',
        't': 'hom',
        'category': 'Квартиры',
        'type': 'Квартира',
        'name': 'I`Moscow',
        'img': Moscow,
        'images': [
            Moscow2,
            Moscow,
            Moscow3,
            Moscow4,
            Moscow5,
            Moscow6,
        ],
        'address': {
            'city': 'Москва',
            'tc': 'ЖК I`Moscow'
        },
        'square': '38',
        'info': [
            'Элитные апартаменты в премиум квартале на Садовом, площадью 38 кв м.',
            'Изюминка  этого небольшого пространства - огромные распашные окна в пол, выходящие во внутренний дворик уютного комплекса.',
            'Система хранения организована во входной зоне, что позволило сделать гостиную местом отдыха и даже спроектировать каминную зону под телевизором.'
        ],
    },
    {
        'id': '12',
        't': 'hom',
        'category': 'Квартиры',
        'type': 'Квартира',
        'name': 'RedSide',
        'img': RedSide,
        'images': [
            RedSide2,
            RedSide3,
            RedSide6,
            RedSide,
            RedSide7,
            RedSide5,
            RedSide4,
            RedSide8,
        ],
        'address': {
            'city': 'Москва',
            'tc': 'ЖК RedSide'
        },
        'square': '88,5',
        'info': [
            'Квартира общей площадью 88,5 кв. м, в премиальном квартале RedSide на ул. Сергея Макеева.',
            'Классический серый, идеальные системы хранения и вид на Москва-Сити – таковы эстетика, функция и класс этой современной квартиры.',
            'Пожелания клиентов: пара попросила создать для каждого по отдельной спальне. Супруги много работают и путешествуют, поэтому ценят комфорт и функциональность. Идеальным для них мог быть интерьер, который не требует постоянного ухода за деталями. Клиенты выбрали мастер-палитрой благородный светло-серый и его оттенки.'
        ],
    },
    {
        'id': '13',
        't': 'hom',
        'category': 'Загородные клубы и дома',
        'type': 'Прованс-отель',
        'name': '4 сезона',
        'img': Provans,
        'images': [
            Provans2,
            Provans3,
            Provans4,
            Provans5,
            Provans6,
            Provans,
        ],
        'address': {
            'city': 'Московская область',
            'tc': 'Серпухов'
        },
        'square': '15 000',
        'info': [
            'Задача создать  единую концепцию лаконичного и узнаваемого стиля для загородного клуба  «4 Сезона» на площади более 1,5 гектар',
            'Прованс-отель «4 сезона» стал первым атмосферный отелем в стиле «Прованс». Дух загородной жизни, а значит уют, комфорт и спокойствие здесь присутствует во всем. «Прованс» – это не просто интерьерный стиль, это и философия, и образ жизни, и провинциальная умиротворяющая атмосфера - всё то, чего не найти в современных мегаполисах, и так не хватает городскому жителю. Мы постарались бережно воплотить самые лучшие черты стиля «Прованс» в этом отеле, чтобы создать уникальную атмосферу тихой французской провинции.'
        ],
    },
    {
        'id': '14',
        't': 'com',
        'category': 'Магазины и бутики',
        'type': 'Бутик',
        'name': 'Contrasto',
        'img': Contrasto,
        'images': [
            Contrasto2,
            Contrasto,
            Contrasto3,
            Contrasto4,
        ],
        'address': {
            'city': 'Москва',
            'tc': 'ТЦ ВРЕМЕНА ГОДА'
        },
        'square': '76',
        'info': [
            'Концепция бутика первоначально заключалась в строгости стиля,  использование черного стекла, хрома, качественного профессионального освещения. В дальнейшем была привнесена идея имитировать в центре подиум в виде трех уровней, как при показе моды в Риме на Испанской лестнице, в том числе для лучшего обзора манекенов на подиуме.',
            'Стена подиума имеет систему цветного управляемого освещения , которая включает несколько сценариев динамического освещения. В потолке над манекенами установлены круглые светильники которые создают необыкновенный эффект за счет сложной системы внутреннего расположения лампы. Из каждого отверстия светят в разные стороны четыре скрытых спота, освещая манекены с разных сторон.',
            'Таким образом манекены на подиуме получаются освещенными с разных сторон, но наблюдатель не видит источников света.',
            'Театральный эффект от освещения с потолка, плюс освещение фона цветным динамическим цветом создают эффект сцены и разыгрывающего на ней спектакля.'
        ],
    },
    {
        'id': '15',
        't': 'com',
        'category': 'Отели и рестораны',
        'type': 'Ресторан',
        'name': 'Китайский',
        'img': Chine,
        'images': [
            Chine2,
            Chine3,
            Chine4,
            Chine5,
            Chine6,
            Chine
        ],
        'address': {
            'city': '',
            'tc': ''}
        ,
        'square': '109,6',
        'info': [
            'Объект коммерческой недвижимости, 1 этаж жилого дома, общей площадью 109,6 м2.',
            'Задача: спроектировать ресторан для китайских гостей. Передать стиль и колорит молодежного заведения в Китае.',
            'В помещении находятся: входная зона, зал для посетителей, зона кухни, зона магазина, зона бара, санузел, кладовая.',
            'Особое внимание уделили освещению, выбрав круглые, похожие на китайские фонарики, светильники. Китайские иероглифы и зелень добавляют интерьеру аутентичности и насыщенности.'
        ],
    },
    {
        'id': '16',
        't': 'com',
        'category': 'Офисы',
        'type': 'Шоурум',
        'name': 'Smeg',
        'img': SmegKazn,
        'images': [
            SmegKazn4,
            SmegKazn14,
            SmegKazn5,
            SmegKazn6,
            SmegKazn7,
            SmegKazn8,
            SmegKazn2,
            SmegKazn9,
            SmegKazn10,
            SmegKazn12,
            SmegKazn13,
            SmegKazn3,
            SmegKazn15,
            SmegKazn16,
        ],
        'address': {
            'city': 'Казань'
        },
        'square': '139',
        'info': [
            'Шоу-рум дизайнерской бытовой техники “SMEG” в г. Казань',
            'Основная идея проекта - создать атмосферу итальянских улочек, оживленных и суетливых. Что решено было в декоре стен и авторской фрески, выполненной дизайнером нашей студии'
        ],
    },
    {
        'id': '17',
        't': 'com',
        'category': 'Офисы',
        'type': 'Съемочная студия',
        'name': 'НОВЫЙ',
        'img': Movie,
        'images': [
            Movie2,
            Movie3,
            Movie,
            Movie4,
            Movie5,
            Movie6,
        ],
        'info': [
            'Задача - создать две съемочные зоны для телеканала "НОВЫЙ" политической направленности.',
            'Дизайн носит современный стильный характер, но с привязкой к исторической преемственности. Направлен на современную, молодежную  аудиторию думающую о своем будущем и будущем страны.'
        ],
    },
    {
        'id': '18',
        't': 'com',
        'category': 'Офисы',
        'type': 'Офис',
        'name': 'Smeg',
        'img': OfSmeg,
        'images': [
            OfSmeg2,
            OfSmeg3,
            OfSmeg4,
            OfSmeg2,
        ],
        'address': {
            'city': 'Москва',
            'tc': 'БЦ W-Plaza'
        },
        'square': '800',
        'info': [
            'Офис и шоу-рум дизайнерской бытовой техники SMEG расположенный в БЦ « W-Plaza»',
            'Офис организован по принципу Open space  с выделением зоны для переговорной, кабинета руководителя и гл.бухгалтера. Стеклянные перегородки позволяют дневному свету проникать в самые удаленные уголки офиса. Сделать офисную работу продуктивнее помогли звукопоглощающие потолочные и напольные покрытия. А система шкафов организована таким образом, что они не заметны, хотя заполняют весь периметр стен офиса.',
            'Шоу-рум предназначен для демонстрации образцов бытовой техники и проведения тренингов и кулинарных мастер-классов для дилеров. Главной задачей было - создать как бы оболочку для строгих, графичных и безупречных в своем совершенстве линий продукции SMEG.'
        ],
    },
    {
        'id': '19',
        't': 'hom',
        'category': 'Квартиры',
        'type': 'Квартира',
        'name': 'Петровский парк',
        'img': Petrovskiy,
        'images': [
            Petrovskiy2,
            Petrovskiy3,
            Petrovskiy4,
            Petrovskiy,
            Petrovskiy2
        ],
        'address': {
            'city': 'Москва',
            'tc': 'Петровский парк'
        }            
    },
    {
        'id': '20',
        't': 'hom',
        'category': 'Квартиры',
        'type': 'Квартира',
        'name': 'I`Moscow',
        'img': IMoscow2,
        'images': [
            IMoscow2,
            IMoscow3,
            IMoscow4,
            IMoscow5,
            IMoscow
        ],
        'address': {
            'city': 'Москва',
            'tc': 'Шлюзовая набережная'
        },
        'square': '65 и 37',
        'info': [
            'Чистоту и лаконичность этих  интерьеров  диктует быстрый ритм мегаполиса.',
            'Задача - создать удобное и функциональное пространство для одного, максимум двух молодых амбициозных, делающих карьеру людей.',
            'Пространство для временного проживания не требующее особого ухода, практичное и современное.'
        ]
            
    },
    {
        'id': '21',
        't': 'com',
        'category': 'Отели и рестораны',
        'type': 'Детский центр',
        'name': 'JET kids',
        'img': Club,
        'images': [
            Club2,
            Club3,
            Club4,
            Club5,
            Club6,
            Club7,
            Club8,
            Club,
        ],
        'address': {
            'city': 'Домодедово',
            'tc': ''
        },
        'info': [
            'Детский центр JET kids — это многофункциональное пространство, продуманное до мелочей.',
            'В него входят: универсальный спортивый зал, игровая комната, современный кабинет коворкинга, уютная кухня.'
        ]
            
    },
    {
        'id': '22',
        't': 'com',
        'category': 'Отели и рестораны',
        'name': 'Коворкинг',
        'img': Covorking,
        'images': [
            Covorking,
            Covorking2
        ],
        'info': [
            'Коворкинг расположен в помещении фитнес клуба.',
            'Концепция помещения решена в соответствии с общей стилистикой и колористической гаммой всего клуба.',
            'Мебель выполнена по эскизам наших дизайнеров. Фито-панно и неоновая световая надпись, также разработана по нашим эскизам'
        ]
            
    },
    {
        'id': '23',
        't': 'com',
        'category': 'Отели и рестораны',
        'type': 'Входная группа',
        'name': 'Ракета',
        'img': Rocket,
        'images': [
            Rocket2,
            Rocket3,
            Rocket4,
            Rocket5,
            Rocket6,
            Rocket7
        ],
        'address': {
            'city': 'Анапа',
            'tc': ''
        },
        'square': '970',
        'info': [
            'Термальная  зона аквапарка «Ракета» в г. Анапа.',
            'Входная группа комплекса разработана в стилистике Джапанди.',
            'Japandi (Japan + Skandi) — так называется смесь японской и скандинавской интерьерных традиций. Несмотря на явные культурные различия, у шведов, датчан и норвежцев есть нечто общее с японцами — подход к оформлению пространства.',
            'И те, и другие ценят минимализм и функциональность, отдают предпочтение природным материалам и естественным формам.',
            'Основные черты: любовь к натуральным материалам, природная цветовая палитра, функциональность, доведённая до совершенства, простота форм, только прямые или округлые линии, никакой замысловатости и сложных узоров.'
        ]
            
    },
    {
        'id': '24',
        't': 'com',
        'category': 'Магазины и бутики',
        'type': 'Бренд-зоны',
        'name': 'Smeg',
        'img': Brand,
        'images': [
            Brand,
            Brand2,
            Brand3,
            Brand4,
            Brand5,
            Brand6,
            Brand7,
            Brand8,
            Brand9,
            Brand11,
            Brand12,
            Brand10,
            Brand13,
            Brand14,
            Brand15,
            Brand16,
            Brand17,
        ],     
    },
    {
        'id': '25',
        't': 'com',
        'category': 'Магазины и бутики',
        'type': 'Витрина',
        'name': 'Smeg',
        'img': Showcase,
        'images': [
            Showcase,
            Showcase,
            Showcase,
            Showcase2,
            Showcase3,
        ],
        info: [
            'Витрина дизайнерской бытовой техники SMEG.',
            'Выполнена в 3-х вариантах со сменой сезона: Весна, Лето, Зима.'
        ]
    },
    {
        'id': '26',
        't': 'com',
        'category': 'Магазины и бутики',
        'type': 'Шоурум',
        'name': 'Smeg',
        'img': SmegKrasn,
        'images': [
            SmegKrasn,
            SmegKrasn2,
            SmegKrasn3,
            SmegKrasn4,
            SmegKrasn5,
        ],
        'address': {
            'city': 'Красноярск',
            'tc': ''
        }
            
    },
    {
        'id': '27',
        't': 'com',
        'category': 'Офисы',
        'type': 'Шоурум',
        'name': 'Smeg Gorenje',
        'img': SmegGorenje,
        'images': [
            SmegGorenje2,
            SmegGorenje3,
            SmegGorenje,
            SmegGorenje4,
            SmegGorenje5,
            SmegGorenje6,
            SmegGorenje7,
            SmegGorenje21,
            SmegGorenje8,
            SmegGorenje9,
            SmegGorenje19,
            SmegGorenje10,
            SmegGorenje11,
            SmegGorenje12,
            SmegGorenje13,
            SmegGorenje14,
            SmegGorenje20,
            SmegGorenje15,
            SmegGorenje16,
            SmegGorenje18,
            SmegGorenje17,
        ],
        'address': {
            'city': 'Казань',
            'tc': ''
        },
        'square': '183',
        'info': [
            'Шоу-рум объединивший 2 крупных бренда Smeg  и  Gorenje   в г. Казань.',
            'На общей площади нужно было создать 2 совершенно разных по стилистике бренда бытовой техники с одной общей переговорной комнатой и складским помещением. С разными входами, вывесками и витринами.',
            'Разработка велась точно по бренд-буку с согласованием в головных офисах  Италии и Словении.',
            '“Монобрендовые зоны SMEG созданы для того, чтобы продемонстрировать особый фирменный стиль SMEG и повысить качество обслуживания клиентов.',
            'Тщательно подобранные коллекции продуктов SMEG являются определяющей философией этих пространств, задуманной для продвижения ценности «MADE IN ITALY» по всему миру.”'
        ]
            
    },
    {
        'id': '28',
        't': 'com',
        'category': 'Офисы',
        'type': 'Шоурум',
        'name': 'Smeg',
        'img': Smeg,
        'images': [
            Smeg2,
            Smeg3,
            Smeg4,
            Smeg5,
            Smeg6,
            Smeg7,
            Smeg8
        ],
        'address': {
            'city': 'Москва',
            'tc': ''
        },
        'square': '550',
        'info': [
            'Московский шоу-рум бренда SMEG. Объем работы 550 кв м.',
            'Обновление шоу-рума, согласно бренд-буку, но с новой концепцией помещения. Минимальные реконструкции и демонтаж существующих экспозиций, минимальный бюджет на реализацию.',
            'Концепция проекта – привнести немного тепла Италии в нашу холодную Москву. Объединить традиции и современность. Яркость и лаконичность. Стиль 60-х и новые технологии.',
            'Подвесные арочные светильники спроектированы в нашей студии.'
        ],
    },
    {
        'id': '29',
        't': 'com',
        'category': 'Офисы',
        'type': 'Офис ',
        'name': 'CROC',
        'img': Croc,
        'images': [
            Croc,
            Croc2,
            Croc7,
            Croc3,
            Croc4,
            Croc5,
            Croc6,
        ],
    },
    {
        'id': '30',
        't': 'com',
        'category': 'Отели и рестораны',
        'type': 'Отель',
        'name': 'Загородный отель',
        'img': Hotel,
        'images': [
            Hotel2,
            Hotel3,
            Hotel4,
            Hotel5,
            Hotel6,
            Hotel7,
            Hotel8,
            Hotel9,
        ],
        info: [
            'Входная зона загородного отеля должна быть уютной, комфортной и стильной, чтобы гости сразу почувствовали атмосферу гостеприимства и радушия. В этой зоне обычно располагаются стойка регистрации, лобби, зона ожидания и гардероб.',
            'Стойка регистрации должна быть удобной и функциональной, чтобы гости могли быстро зарегистрироваться и получить всю необходимую информацию об отеле и услугах. Лобби должно быть просторным, светлым и оформленным в соответствии с общим стилем отеля.',
            'Наши дизайнеры воплотили все эти принципы в проектировании нового отеля.'
        ]
    },
    {
        'id': '31',
        't': 'com',
        'category': 'Офисы',
        'type': 'Шоурум',
        'name': 'ASCO',
        'img': Room,
        'images': [
            Room,
            Room,
            Room2,
            Room3,
            Room4,
        ],
        info: [
            'Шоу-рум бытовой техники для компании ASCO был реконструирован с учётом принципов высокого качества, функциональности и удобства для клиентов.',
            'Пространство разделено на зоны прачечной, кухни с мастер-классами и экспозиции встраиваемой техники.',
            'Цветовая гамма и дизайн интерьера выполнены в стиле хай-тек, а техника ASKO является главным акцентом шоу-рума.'
        ]
    },
    {
        'id': '32',
        't': 'com',
        'category': 'Выставки',
        'type': 'Выставка',
        'name': 'Русский дом',
        'img': Exhibition10,
        'images': [
            Exhibition4,
            Exhibition3,
            Exhibition2,
            Exhibition4,
            Exhibition5,
            Exhibition6,
            Exhibition7,
            Exhibition8,
            Exhibition9,
            Exhibition,
            Exhibition10,
            Exhibition11,
            Exhibition12,
            Exhibition13,
            Exhibition14,
            Exhibition15,
            Exhibition16,
        ],
        info: [
            'Рады пригласить вас на выставку «Русский дом»!',
            'Место проведения: Стильное лофт-пространство в центре Москвы, на Дербеневской набережной 7',
            'На выставке «Русский дом» представлена наша капсульная коллекция. Это прекрасная возможность встретиться с нами и другими топовыми дизайнерами, узнать больше о наших продуктах и услугах, а также вдохновиться новыми идеями и тенденциями отрасли.',
            'Мы участвуем в этой выставке и приглашаем вас присоединиться к этому событию и открыть для себя новые горизонты в дизайне и архитектуре!',
            '«Русский дом» — это международная выставка дизайна интерьеров и технологий, направленная на воссоединение с историческими и культурными корнями через современные интерьерные решения.',
            'Идея нашей капсулы “Уральское Бали”',
            'Мы хотим помочь туристам в изучении нашей необъятной Родины и предоставить максимальный комфорт в путешествиях с помощью проектирования атмосферных эко-отелей по всей России. Наша капсула представляет собой мини версию лобби отеля.  Мы вдохновились природой и традициями Южного Урала. Это нашло отражение в орнаментах и флористике. А также уникальным местом - Каолиновым карьером «Уральское Бали»',
            'Мы стараемся создавать эргономичные, эстетичные, яркие интерьеры. Обязательно экологичные – с благодарностью природе и восхищением перед ее красотой.  Мы с радостью участвуем в строительстве эко-отелей. На выставке «Русский Дом 2024» компания представила капсулу «Уральское Бали». Так, по имени живописного озера в Челябинской области, мы назвали свою мини-версию лобби отеля.',
            'Озеро олицетворяло зеркало нашей капсулы с белым гипсовым обрамлением, напоминающим белые берега прекрасного бирюзового водоема. Природа и традиции Южного Урала нашли своё отражение в узорах и флористике нашего проекта.',
            'Капсула получила премию Ridu Design Awаrds 2024 как лучшая капсула с русским культурным кодом!'
        ]
    },
    {
        'id': '33',
        't': 'hom',
        'category': 'Квартиры',
        'type': 'Квартира',
        'name': 'Holland Park',
        'img': Holland2,
        'images': [
            Holland,
            Holland2,
            Holland,
            Holland3,
            Holland4,
            Holland5,
            Holland6,
            Holland7,
            Holland9,
            Holland8,
            Holland10,
            Holland11,
            Holland12,
            Holland13,
            Holland14,
            Holland16,
            Holland17,
            Holland15,
            Holland19,
            Holland20,
            Holland18,
        ],
        'address': {
            'city': 'Москва',
            'tc': 'ЖК Holland Park'
        },
        'square': '41', 
        info: [
            'Интерьер квартиры площадью 41 кв.м, созданный специально для молодой семейной пары. В проекте доминируют темные оттенки, создавая особую “вечернюю” атмосферу уюта и комфорта.',
            'Концепция интерьера построена на монохромной гамме, где черный цвет выступает главным элементом декора. Это решение придает пространству выразительность и позволяет аксессуарам, живописи и мебели стать настоящими акцентами в интерьере.',
            'Освещение продумано по зонам с использованием скрытой подсветки, что создает многоуровневый световой сценарий. Гладкие поверхности без лишних орнаментов делают интерьер глубоким, а продуманные фактуры и текстуры добавляют пространству характер.',
            'Этот проект демонстрирует, что темное пространство может быть не только стильным, но и уютным, идеально подходящим для повседневной жизни современной семьи.'
        ]          
    },
    {
        'id': '34',
        't': 'com',
        'category': 'Выставки',
        'type': 'Выставка',
        'name': 'Русский дом',
        'img': ExhibitionCity11,
        'images': [
            ExhibitionCity15,
            ExhibitionCity3,
            ExhibitionCity4,
            ExhibitionCity5,
            ExhibitionCity6,
            ExhibitionCity7,
            ExhibitionCity8,
            ExhibitionCity9,
            ExhibitionCity10,
            ExhibitionCity11,
            ExhibitionCity12,
            ExhibitionCity13,
            ExhibitionCity14,
            ExhibitionCity15,
            ExhibitionCity16,
            ExhibitionCity17,
        ],
        info: [
            'Эко-капсула «Каменный город» — это погружение в мистический мир горной России, где современность встречается с древними легендами. Пространство капсулы создано как собирательный образ нетронутой природы и самобытной культуры российских гор.',
            'Эко-отели будущего — это не просто места для отдыха, а пространства, где современные технологии сочетаются с уважением к природе. Мы создаем комфортные условия для путешественников, сохраняя первозданную красоту российских гор.',
            'Атмосферный дизайн капсулы воплощает идею единения человека с природой. Натуральные материалы, каменные текстуры создают эффект пребывания в настоящем горном отеле. Каждый элемент интерьера рассказывает историю о величии и красоте российской природы.',
            'Минимальное воздействие на окружающую среду',
            'Использование возобновляемых источников энергии',
            'Локальные материалы и ремесленные традиции',
            'Интеграция в природный ландшафт',
            'Откройте для себя необъятные просторы России через призму современного экологического туризма. Наша миссия — сделать знакомство с горными регионами доступным и комфортным, сохраняя их уникальную самобытность для будущих поколений.',
            'Приглашаем вас в путешествие по «краю без окраин», где каждый уголок России становится частью незабываемого приключения.',
        ]
    },
]

export const Categories = [
    {
        'id': '1',
        'name': 'Все'
    },
    {
        'id': '2',
        'name': 'Офисы'
    },
    {
        'id': '3',
        'name': 'Отели и рестораны'
    },
    {
        'id': '4',
        'name': 'Магазины и бутики'
    },
    {
        'id': '5',
        'name': 'Квартиры'
    },
    {
        'id': '6',
        'name': 'Загородные клубы и дома'
    },
    {
        'id': '7',
        'name': 'Выставки'
    },
]